export default "__VITE_ASSET__CfMtScsq__"